module.exports = __webpack_public_path__ + "static/img/gm_open05.82c4bb24.png";